import { ZoomInIcon } from '@radix-ui/react-icons';
import { Card, Code, Flex, Strong } from '@radix-ui/themes';
import { CommonDetails } from 'components/common/details';
import { ErrorBoundary } from 'components/common/error-boundary';
import { JsonViewer } from 'components/common/json/json-viewer';
import { parseISO } from 'date-fns';
import format from 'date-fns-tz/format';
import { LOCAL_TIMEZONE } from 'lib_ts/enums/datetime.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IEvalModelResult } from 'lib_ts/interfaces/modelling/i-eval-models';
import { FC, useState } from 'react';

interface IProps {
  open?: boolean;

  metric: IEvalModelResult;

  /** appended to summary in details */
  index?: number;
}

export const PrintMetric: FC<IProps> = (props) => {
  const [timestamp] = useState(
    format(parseISO(props.metric.created), 'yyyy-MM-dd @ hh:mm:ss a', {
      timeZone: LOCAL_TIMEZONE,
    })
  );

  return (
    <ErrorBoundary identifier="PrintMetric">
      <Card>
        <CommonDetails
          className="PrintMetric"
          summaryContent={
            <Flex justify="between" gap={RADIX.FLEX.GAP.SM}>
              <Strong>
                <ZoomInIcon />{' '}
                {props.metric
                  ? props.metric.model_name
                  : `Metric #${props.index}`}
              </Strong>

              <Code>{timestamp}</Code>
            </Flex>
          }
          defaultOpen={props.open}
        >
          <JsonViewer value={props.metric.model_performance} />
        </CommonDetails>
      </Card>
    </ErrorBoundary>
  );
};
